export default __webpack_public_path__ + "static/media/informations.c08d7926.svg";